// @systeme: interface
// Point d'entrée du client : thème, session, messages, routes, service worker.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { registerSW } from 'virtual:pwa-register';
import { MessagesProvider } from './composants/Messages';
import { RoutesApplication } from './routes';
import { SessionProvider } from './session/SessionContext';
import { theme } from './theme/theme';

// Le service worker met l'application en cache pour qu'elle s'ouvre sans réseau, et se
// met à jour tout seul à la prochaine ouverture.
registerSW({ immediate: true });

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément racine introuvable.');

createRoot(racine).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <SessionProvider>
          <MessagesProvider>
            <RoutesApplication />
          </MessagesProvider>
        </SessionProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
